import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as moment from 'moment';
@Component({
  selector: 'app-print-layout',
  templateUrl: './print-layout.component.html',
  styleUrls: ['./print-layout.component.css']
})
export class PrintLayoutComponent implements OnInit {

  constructor(private router: Router) { }

  public titulo = "";
  public data = moment().format('DD/MM/YYYY HH:mm:ss');

  ngOnInit() {
    this.titulo = this.pegaTitulo();
    
    setTimeout(function(){
      print();
      window.close();
    }, 1500);
  }

  pegaTitulo(){
    switch(this.router.url.split('/')[2]){
      case 'checkambulancia':  
        return 'Checklist'
      default :
        return '';
    }
  }
}
 